/** Navbar + loading horizontal lockup — replace `public/qovarix-logo-NAVBER.png` with your final asset anytime. */
export const QOVARIX_NAVBAR_LOGO_PATH = "/qovarix-logo-NAVBER.png";
